module.exports = __webpack_public_path__ + "static/img/6.1f19d64.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/sp/6.png
// module id = Xl7K
// module chunks = 0